/**
 * File: studentViewLearningProgress.js
 * Project: educore
 * Created Date: 2019-01-31
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class StudentLearningController {
    // @ngInject
    constructor($scope, $state, $rootScope, authService, localStorageService, UserPrivilages, TPWIZARDCONSTANT, $stateParams, ARCHIVE_CONSTANTS) {
        //On init function
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }

        //On destroy function
        this.$onDestroy = () => { }
        let authoring = localStorageService.get('authoringData')

        //String - teaching plan id
        let planId = $state.params.planId
        let userId = localStorageService.get('user_id')

        //[Object] - Different resource type assigned
        $scope.resourcesAvailable = [];

        //[Object] - Contains chart data
        $scope.chartArray = []

        //Number - To set width of chart
        $scope.chartWidth = 450;

        //Number - To set height of chart
        $scope.chartHeight = 350;

        //[Object] - Holds list of chart details
        $scope.chartImgData = []
        authService.callAPI(TPWIZARDCONSTANT.API_GET_ASSIGNED_RESOURCES + planId + '/' + userId, "GET", {}, function (response) {
            if (response.result && response.result.data && response.result.data.data.length > 0) {
                try {
                    let resultData = response.result.data.data
                    if (resultData && resultData.length > 0) {
                        _.map(resultData, function (res) {
                            res["isActive"] = false;
                            return res;
                        })
                        $scope.resourcesAvailable = resultData;
                        $scope.resourcesAvailable.forEach(resource => {
                            ARCHIVE_CONSTANTS.ARCHIVE_RESOURCE_TYPES.forEach(contResourse => {
                                if (resource._id === contResourse._id)
                                    resource.name = contResourse.name
                            })
                        });
                        console.log(ARCHIVE_CONSTANTS.ARCHIVE_RESOURCE_TYPES)
                        console.log($scope.resourcesAvailable)
                        $scope.resourcesAvailable[0].isActive = true;
                        $scope.showProgressChart($scope.resourcesAvailable[0])
                    }
                } catch (ex) {
                    console.log(ex);
                }
                _.defer(function () {
                    $scope.$apply();
                });
            }
        });
        $scope.showProgressChart = function (resource) {
            _.each($scope.resourcesAvailable, function (res) {
                if (res.isActive)
                    res.isActive = false
            })
            resource.isActive = true
            let obj = {
                "type": resource.type,
                "plan_id": planId,
                "student_id": userId
            }
            $scope.chartArray = []
            authService.callAPI(TPWIZARDCONSTANT.API_GET_LEARNING_PROGRESS, "POST", obj, function (response) {
                if (response.result && response.result.data && response.result.data.data.length > 0) {
                    $scope.resourceData = response.result.data.data
                    let values = []
                    let header = []
                    header.push("Resource")
                    header.push("View Count")
                    values.push(header)
                    _.each($scope.resourceData, function (data, index) {
                        let arr = []
                        arr.push(data.title)
                        arr.push(data.count)
                        values.push(arr)
                    })
                    $scope.quesObj = {
                        'key': "Resource",
                        'graph': "Donut",
                        'title': "Resource" + '  vs  ' + "View Count",
                        'value': values
                    }
                    $scope.chartArray.push($scope.quesObj)
                    _.defer(function () {
                        $scope.$apply();
                    });
                }
            })
        }

        function convertFileToDataURLviaFileReader(url, callback) {
            var xhr = new XMLHttpRequest();
            xhr.onload = function () {
                var reader = new FileReader();
                reader.onloadend = function () {
                    callback(reader.result);
                }
                reader.readAsDataURL(xhr.response);
            };
            xhr.open('GET', url);
            xhr.responseType = 'blob';
            xhr.send();
        };

        /*
         * To get chart details from Child chart component
         * 
         * @data : Object - Chart details
         * 
         * @return : null
         */
        $scope.getChartData = function (data) {
            if (data != undefined && data[0] != undefined) {
                $scope.chartImgData = []
                $scope.chartImgData.push(data[0])
            }
        }

        /*
         * To export chart as PDF file
         * 
         * @return : null
         */
        $scope.exportAsPDF = function () {
            var doc = new jsPDF('p', 'pt', 'a4', false) /* Creates a new Document*/
            doc.addImage($scope.imgurl1, 'png', 50, 30, 70, 70, undefined, 'none');
            doc.setFontSize(18);
            doc.setFontType('bold');
            var xOffset = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth($scope.schoolHeader.schoolName) * doc.internal.getFontSize() / 2);
            doc.text(xOffset, 50, $scope.schoolHeader.schoolName);
            doc.setFontSize(12);
            doc.setFontType('normal');
            doc.text(230, 70, 'Academic Year : ' + $scope.schoolHeader.academicYear);
            doc.setFontSize(16);
            doc.text(240, 90, 'Usage Report');
            doc.setFontSize(15); /* Define font size for the document */
            var yAxis = 150;

            for (var i = 0; i < $scope.chartImgData.length; i++) {
                if (i % 2 == 0 && i != 0) { /* I want only two images in a page */
                    doc.addPage(); /* Adds a new page*/
                    yAxis = 30; /* Re-initializes the value of yAxis for newly added page*/
                }

                var width = doc.internal.pageSize.width; //$scope.imageTags[i].width;
                var height = $scope.chartImgData[i].height - 100; //doc.internal.pageSize.height;

                if (doc.internal.pageSize.width <= $scope.chartImgData[i].width) {
                    width = doc.internal.pageSize.width;
                } else {
                    width = $scope.chartImgData[i].width;
                }

                height = $scope.chartImgData[i].height * width / doc.internal.pageSize.width;
                height = width * (3 / 4) - 100

                var someText = (i + 1) + ".) " + $scope.chartImgData[i].title;
                doc.text(60, yAxis, someText); /* Add some text in the PDF */
                yAxis = yAxis + 20; /* Update yAxis */
                //doc.addImage($scope.imageTags[i].image, 'png', 40, yAxis, 530, 350, undefined, 'none');
                doc.addImage($scope.chartImgData[i].image, 'png', 0, yAxis, width, height, undefined, 'none');
                yAxis = yAxis + 360; /* Update yAxis */
            }
            window.open(doc.output('bloburl'))
            // doc.save('Usage_Report.pdf')
        }
    }
}
export default StudentLearningController;



// WEBPACK FOOTER //
// ./src/app/authoring-tool/wizard/controllers/reports/studentViewLearningProgress.js